import { defineMessages } from 'react-intl';

const translations = {
  breadcrumb: {
    shipments: {
      id: 'pages.parcelView.breadcrumb.shipments',
      defaultMessage: 'Shipments',
      description: 'label of the shipment breadcrumb',
    },
    parcels: {
      id: 'pages.parcelView.breadcrumb.parcels',
      defaultMessage: 'Parcels',
      description: 'label of the parcels breadcrumb',
    },
  },
  subNavigation: {
    details: {
      id: 'pages.parcelView.subNavigation.details',
      defaultMessage: 'Details',
      description: 'label of the details sub navigation tab',
    },
    items: {
      id: 'pages.parcelView.subNavigation.items',
      defaultMessage: 'Items',
      description: 'label of the items sub navigation tab',
    },
    logs: {
      id: 'pages.parcelView.subNavigation.logs',
      defaultMessage: 'Logs',
      description: 'label of the logs sub navigation tab',
    },
  },
  secondaryActions: {
    deleteParcel: {
      id: 'pages.parcelView.secondaryActions.deleteParcel',
      defaultMessage: 'Delete',
      description: 'label of the delete parcel action',
    },
    editParcelItems: {
      id: 'pages.parcelView.secondaryActions.editParcelItems',
      defaultMessage: 'Edit items',
      description: 'label of the edit items action',
    },
    markFinished: {
      id: 'pages.parcelView.secondaryActions.markFinished',
      defaultMessage: 'Mark as finished',
      description: 'label of the mark finished action',
    },
    markInTransit: {
      id: 'pages.parcelView.secondaryActions.markInTransit',
      defaultMessage: 'Mark as in transit',
      description: 'label of the mark in transit action',
    },
    printLabel: {
      id: 'pages.parcelView.secondaryActions.printLabel',
      defaultMessage: 'Print shipping label',
      description: 'label of the print shipping label action',
    },
    printSlip: {
      id: 'pages.parcelView.secondaryActions.printSlip',
      defaultMessage: 'Print shipping slip',
      description: 'label of the print shipping slip action',
    },
    printTicket: {
      id: 'pages.parcelView.secondaryActions.printTicket',
      defaultMessage: 'Print parcel ticket',
      description: 'label of the print parcel ticket action',
    },
  },
  confirmDeleteParcel: {
    title: {
      id: 'pages.parcelView.confirmDeleteParcel.title',
      defaultMessage: 'Delete parcel',
      description: 'Title of the confirm delete parcel dialog',
    },
    description: {
      id: 'pages.parcelView.confirmDeleteParcel.description',
      defaultMessage:
        'Are you sure you would like to delete this parcel? This action can`t be undone.',
      description: 'Description of the confirm delete parcel dialog',
    },
    buttons: {
      cancel: {
        id: 'pages.parcelView.confirmDeleteParcel.buttons.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel button of the confirm delete parcel dialog',
      },
      delete: {
        id: 'pages.parcelView.confirmDeleteParcel.buttons.delete',
        defaultMessage: 'Delete',
        description: 'Label of the delete button of the confirm delete parcel dialog',
      },
    },
  },
  progressDialog: {
    label: {
      fetching: {
        id: 'pages.parcelView.progressDialog.label.fetching',
        defaultMessage: 'Fetching shipping label',
        description: 'Message of the progress dialog for fetching shipping labels',
      },
      printing: {
        id: 'pages.parcelView.progressDialog.label.printing',
        defaultMessage: 'Print shipping label',
        description: 'Message of the progress dialog for printing shipping labels',
      },
    },
    slip: {
      fetching: {
        id: 'pages.parcelView.progressDialog.slip.fetching',
        defaultMessage: 'Fetching shipping slip',
        description: 'Message of the progress dialog for fetching shipping labels',
      },
      printing: {
        id: 'pages.parcelView.progressDialog.slip.printing',
        defaultMessage: 'Print shipping slip',
        description: 'Message of the progress dialog for printing shipping slip',
      },
    },
    ticket: {
      fetching: {
        id: 'pages.parcelView.progressDialog.ticket.fetching',
        defaultMessage: 'Fetching parcel ticket',
        description: 'Message of the progress dialog for fetching parcel ticket',
      },
      printing: {
        id: 'pages.parcelView.progressDialog.ticket.printing',
        defaultMessage: 'Print parcel ticket',
        description: 'Message of the progress dialog for printing parcel ticket',
      },
    },
  },
  printingFailedDialog: {
    label: {
      title: {
        id: 'pages.parcelView.printingFailedDialog.label.title',
        defaultMessage: 'Printing shipping labels failed',
        description: 'Title of the printing failed dialog for fetching shipping labels',
      },
      message: {
        id: 'pages.parcelView.printingFailedDialog.label.message',
        defaultMessage: 'Could not print the shipping label',
        description: 'Message of the printing failed dialog for printing shipping labels',
      },
    },
    slip: {
      title: {
        id: 'pages.parcelView.printingFailedDialog.slip.title',
        defaultMessage: 'Printing shipping slip failed',
        description: 'Title of the printing failed dialog for fetching shipping slip',
      },
      message: {
        id: 'pages.parcelView.printingFailedDialog.slip.message',
        defaultMessage: 'Could not print the shipping slip',
        description: 'Message of the printing failed dialog for printing shipping slip',
      },
    },
    ticket: {
      title: {
        id: 'pages.parcelView.printingFailedDialog.ticket.title',
        defaultMessage: 'Printing parcel ticket failed',
        description: 'Title of the printing failed dialog for printing parcel ticket',
      },
      message: {
        id: 'pages.parcelView.printingFailedDialog.ticket.message',
        defaultMessage: 'Could not print the parcel ticket',
        description: 'Message of the printing failed dialog for printing parcel ticket',
      },
    },
  },
  feedback: {
    noShippingMethod: {
      id: 'pages.parcelView.feedback.noShippingMethod',
      defaultMessage: 'The shipment has no shipping method',
      description: 'Error message of the print shipping label action when no shipping method',
    },
    parcelDeleted: {
      id: 'pages.parcelView.feedback.parcelDeleted',
      defaultMessage: 'Parcel is deleted',
      description: 'Success message of the delete parcel action',
    },
    parcelNotDeleted: {
      id: 'pages.parcelView.feedback.parcelNotDeleted',
      defaultMessage: 'Parcel could not be deleted',
      description: 'Error message of the delete parcel action',
    },
    parcelMarkedInTransit: {
      id: 'pages.parcelView.feedback.parcelMarkedInTransit',
      defaultMessage: 'Parcel has been marked as in transit',
      description: 'Success message of the mark parcel in transit action',
    },
    parcelNotMarkedInTransit: {
      id: 'pages.parcelView.feedback.parcelNotMarkedInTransit',
      defaultMessage: 'Parcel could not be marked as in transit',
      description: 'Error message of the mark parcel in transit action',
    },
    parcelMarkedFinished: {
      id: 'pages.parcelView.feedback.parcelMarkedFinished',
      defaultMessage: 'Parcel has been marked as finished',
      description: 'Success message of the mark parcel in transit action',
    },
    parcelNotMarkedFinished: {
      id: 'pages.parcelView.feedback.parcelNotMarkedFinished',
      defaultMessage: 'Parcel could not be marked as finished',
      description: 'Error message of the mark parcel in transit action',
    },
  },
};

export default defineMessages(translations);
